module.exports = __webpack_public_path__ + "assets/img/footer_03.97510deb.png";